---
title: My experience at Redjack
coverImage: /blog/assets/images/pv-sports.avif
date: 2023-09-26T02:32:00.000Z
updated: 2023-11-10T04:53:49.000Z
excerpt: Blog Template
hidden: true
tags:
  - Jobs
---

<script>
	import SparklingHighlight from "@lib/components/molecules/SparklingHighlight.svelte"; import Callout from
	"@lib/components/atoms/Callout.svelte"; import CodeBlock from "@lib/components/molecules/CodeBlock.svelte"; import
	Image from "@lib/components/atoms/Image.svelte";
</script>

## Applying

### Interview Process

### Recruiter

### Technical

### Behavioral

## What did I work on?

### BonnyBot

### Sensor

### Inventory

a<a><SparklingHighlight color="secondary">Anomaly Detection!</SparklingHighlight></a>a

### Clustering

### Federation

### What did I learn?
